import { RecommendationDatastoreService } from 'app-core/src/services/datastore-service/recommendation-datastore.service';

// -----------------------------------------------------------------------------
export const kNameOfSubGameHandler = 'SubGameHandler';

// -----------------------------------------------------------------------------
// Base class for per-game sub-game handlers. The list of sub-game IDs lives
// on the recommendation config (Game.subGameIds), so all the base class needs
// is the shared datastore service.
//
// Subclasses must:
//   - declare `public readonly gameId = <gameId>;`
//   - implement `getOrderedCandidates()`, calling
//     `this.readSubGameIdsFromConfig()` to get the raw list.
export abstract class SubGameHandler {
  public abstract readonly gameId: number;

  // ---------------------------------------------------------------------------
  public constructor(
    protected readonly datastore: RecommendationDatastoreService,
  ) {}

  // ---------------------------------------------------------------------------
  // Returns sub-game IDs to probe in priority order. The first one that
  // produces a notification wins; the rest are skipped.
  public abstract getOrderedCandidates(): Promise<number[]>;

  // ---------------------------------------------------------------------------
  protected async readSubGameIdsFromConfig(): Promise<number[]> {
    const game = await this.datastore.getGame(this.gameId);
    return game?.subGameIds ?? [];
  }
}
